<template>
  <div class="solution_wrap">
    <div class="top-img_container">
      <DragCarousel :images="imgData"></DragCarousel>
    </div>
    <NavTools :displaySecNav="false"></NavTools>
    <router-view></router-view>
  </div>
</template>

<script>
  import DragCarousel from '@/components/drag-carousel/index.vue';
  import NavTools from '@/layouts/components/NavTools.vue';
  export default {
    components: { NavTools, DragCarousel },
    data() {
      return {
        imgData: [
          {
            src: require('@/assets/img/solution/solutionBj.jpg'),
            alt: '解决方案'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="scss">
 .solution_wrap {
   width: 100%;
   height: 100%;
 }
 .top-img_container {
   margin-top: 80px;
   @media screen and (max-width: 768px) {
     margin: 0;
   }
 }
</style>
